import Modal from '../scripts/modal'
import merge from 'lodash.merge';
import AddGroupModal from "./add-group-modal";
import sort from "array-sort";

class SelectGroupModal {

  constructor (settings = {}) {

    this.groups = [];

    this.settings = merge({
      selectedSensors: [],
      onSuccess: null,
    }, settings);

    this.modal = new Modal({
      title: 'Set Sensor Groups',
    });

    if(this.settings.selectedSensors.length === 0) {

      this.modal.setContent(`
      <div class="select-group-form__content">
        <p>You don't have any sensors selected, please select some sensors first</p>
      </div>
      `);

      return;

    }

    this.modal.setContent(`
    <form class="select-group-form select-group">

      <div class="select-group-form__content">

        <div class="setting">
          <div class="setting__label">Select groups</div>
          <div class="group-list">Loading...</div>
        </div>
        <div class="setting__description">Select which groups to apply to these sensors, this will change the group(s) for 
          <b>${this.settings.selectedSensors.length} ${this.settings.selectedSensors.length > 1 ? 'sensors' : 'sensor'}</b>.
        </div>

      </div>

      <div class="setting-save">
        <div class="setting-save__button">
          <button type="submit" class="button button--blue">Save Groups</button>
          <button type="button" class="button button--black" data-action="create_group">Create Group</button>
        </div>
        <div class="setting-save__message"></div>
      </div>

    </form>
    `);

    this.form = this.modal.getContainer().querySelector('form');

  }

  async getGroups() {

    const response = await apiRequest("get", "/groups");

    if(response.type === 'success') {
      this.groups = response.data;
      this.groups = sort(this.groups, 'group_name', {});
    }

  }

  async updateSensorGroupsSelect() {

    const $list = $(this.modal.getContainer()).find('.group-list');

    await this.getGroups();

    let html = '';

    if (this.groups.length > 0) {

      for (let group of this.groups) {

        let isChecked = false;

        for (let sensorId of this.settings.selectedSensors) {
          let sensor = window.currentSensors[sensorId];
          if (sensor.groups.some(sensorGroup => sensorGroup.id === group.id)) {
            isChecked = true;
          }
        }

        html += `
          <label class="group-list-item">
          <input name="group_ids[]" type="checkbox" value="${group.id}" ${isChecked ? 'checked' : ''} />
          ${window.escapeHTML(group.group_name)}
          </label>
        `;
      }
    } else {
      html = `<p>You don't have any groups created, create one first.</p>`;
    }

    $list.html(html);

  }

  async init() {

    this.updateSensorGroupsSelect();
    this.modal.open();

    $(this.modal.getContainer()).on('click', 'button[data-action="create_group"]', e => {

      const modal = new AddGroupModal({
        onClose: () => {

        },
        onSuccess: group => {

          // Check if the group already exists in this.groups based on group.id
          if (!this.groups.some(g => g.id === group.id)) {
            this.groups.push(group);
          }

          this.updateSensorGroupsSelect(group);

        }
      });

      modal.init();

    });

    $(this.modal.getContainer()).on('change', 'select[name="sensor_group"]', e => {

      const value = $(e.currentTarget).val();
      const $create_group_name = $(this.modal.getContainer()).find('.setting[data-for="group_name"]');

      if(value === 'create') {
        $create_group_name.show();
      } else {
        $create_group_name.hide();
      }

    });

    $(this.form).on("submit", async e => {

      e.preventDefault();

      // Serialize the form data
      let data = $(this.form).serializeArray();

      // Add selected sensors to the data
      this.settings.selectedSensors.forEach(sensorId => {
        data.push({ name: "sensors[]", value: sensorId });
      });

      // convert data back to URL-encoded string if needed
      const serializedData = $.param(data);

      const result = await apiRequest('post', '/groups/assign', serializedData);

      console.log("assign group", result);

      if(this.settings.onSuccess && result.type === 'success') {
        this.settings.onSuccess(result.data);
      }

      this.modal.close();

    })

  }

}

export default SelectGroupModal;
